import React, { ReactElement } from 'react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { FOODS_TABLE_COLUMN, FoodsTableColumn } from '../NgzFoods.settings';

type TitleRowProps = {
  visibleColumns: FoodsTableColumn[];
};

const TitleRow = ({ visibleColumns }: TitleRowProps) => {
  const renderColumnsInfo: Record<FoodsTableColumn, ReactElement> = {
    [FOODS_TABLE_COLUMN.NAME]: <GridTableCell>Name</GridTableCell>,
    [FOODS_TABLE_COLUMN.BRAND]: <GridTableCell>Brand</GridTableCell>,
    [FOODS_TABLE_COLUMN.QTY]: <GridTableCell>Qty</GridTableCell>,
    [FOODS_TABLE_COLUMN.MEASUREMENT]: <GridTableCell>Measurement</GridTableCell>,
    [FOODS_TABLE_COLUMN.PROTEIN]: <GridTableCell>Protein</GridTableCell>,
    [FOODS_TABLE_COLUMN.CARB]: <GridTableCell>Carb</GridTableCell>,
    [FOODS_TABLE_COLUMN.FATS]: <GridTableCell>Fats</GridTableCell>,
    [FOODS_TABLE_COLUMN.RECOMMENDATIONS]: <GridTableCell>Recommended</GridTableCell>,
    [FOODS_TABLE_COLUMN.TAG]: <GridTableCell>Tag</GridTableCell>,
    [FOODS_TABLE_COLUMN.ACTIONS]: <div />,
  };

  return (
    <GridTableRow variant="header">
      {visibleColumns.map((column) => (
        <React.Fragment key={column}>{renderColumnsInfo[column]}</React.Fragment>
      ))}
    </GridTableRow>
  );
};

export { TitleRow };
